module.exports = __webpack_public_path__ + "static/media/block-img-six.ba80eb03.svg";